import Connect from './Connect'

/**
 * Renders a Connect control from a standard connect field config
 * (same shape as a cardViewData connect group entry).
 *
 * Props:
 *   config   — connect field config: { id, display, entity, valueMap, placeholder,
 *               modalTitle, options, entityParams, menuItemField, listDisplay,
 *               persistValue, manualEntry, width, marginBottom }
 *   value    — state object, e.g. { projectId: 'abc', projectName: 'My Project' }
 *   onChange — called with Connect's synthetic event array
 *   width    — overrides config.width
 */
const ConnectField = ({ config, value, onChange, width }) => {
    return (
        <Connect
            entity={config.entity}
            name={config.id}
            id={config.id}
            mainValueId={value?.[config.id] ?? ''}
            valueName={value?.[config.displayField] ?? ''}
            valueMap={config.valueMap}
            setValue={onChange}
            options={config.options}
            modalTitle={config.modalTitle}
            placeholder={config.placeholder}
            menuItemField={config.menuItemField || 'name'}
            listDisplay={config.listDisplay}
            entityParams={config.entityParams}
            testId={config.testId ?? config.id}
            persistValue={config.persistValue || false}
            manualEntry={config.manualEntry || false}
            $width={width ?? config.width}
            $marginBottom={config.marginBottom ?? '0'}
        />
    )
}

export default ConnectField
